import usePrivateAxios from '@/common/api/usePrivateAxios';
import { useMutation } from '@tanstack/react-query';

interface UseBillingPaymentMarkAsUnpaid {
  paymentId?: string;
  onSuccess?: (response: any) => void;
  onError?: (response: any) => void;
}

export const useBillingPaymentMarkAsUnpaid = ({ paymentId, onSuccess, onError }: UseBillingPaymentMarkAsUnpaid) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['billingPaymentMarkAsUnpaid', paymentId],
    mutationFn: () => privateAxios.put(`/billing/payments/${paymentId}/mark_as_unpaid`),
    onSuccess,
    onError,
  });
};
